import { CartaoPagarResponse } from '../../types/otp'

/**
 * Reconhece o pagamento aprovado exclusivamente pelo contrato HTTP.
 *
 * O `pagar()` da API só devolve 200 quando a transação foi aprovada, sempre com
 * `retorno: true`. O `cartao_de_credito` repassa a mensagem literal do emissor,
 * que varia por bandeira e pode mudar sem aviso: comparar esse texto fazia um
 * pagamento aprovado cair no ramo de falha — cliente cobrado, linha não
 * entregue.
 */
export default function isPaymentApproved(
  status: number,
  body: CartaoPagarResponse | undefined
): boolean {
  return status === 200 && body?.retorno === true
}
